import script from "./PandyTransferItemTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PandyTransferItemTable.vue?vue&type=script&setup=true&lang=js"

import "./PandyTransferItemTable.vue?vue&type=style&index=0&id=fa6bb34e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa6bb34e"]])

export default __exports__